import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Link, Switch, withRouter, Redirect } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { intersection } from 'lodash'

import { logout, recoverSession, loadGlobals, closePatientRecord } from '../actions'

import { isAuthenticated, canRecover } from '../services/sessionService'
import { showAbout } from '../services/miscService'

import Profile from '../views/Profile'
import Backup from '../views/Backup';
import Contact from '../views/Contact'
import Patients from '../views/Patients'
import PatientSheet from '../views/PatientSheet';
import PatientSemiology from '../views/PatientSemiology';
import PatientObservations from '../views/PatientObservations';
import PatientBloodTests from '../views/PatientBloodTests';
import PatientBiologyFunction from '../views/PatientBiologyFunction';
import PatientActions from '../views/PatientActions';
import PatientPlants from '../views/PatientPlants';
import Consultations from '../views/Consultations'
import Actions from '../views/Actions'
import Action from '../views/Action'
import Plants from '../views/Plants'
import Plant from '../views/Plant'
import Registrations from '../views/Registrations'
import Doctors from '../views/Doctors'
import Users from '../views/Users'
import User from '../views/User'
import SettingsGenericCombo from '../views/SettingsGenericCombo'
import SettingsLaboratories from '../views/SettingsLaboratories'
import SettingsNorms from '../views/SettingsNorms'
import SettingsOther from '../views/SettingsOther'
import Messages from '../views/Messages'
import Reports from '../views/Reports'
import Report1 from '../views/Report1'
import Report2 from '../views/Report2'
import Report3 from '../views/Report3'
import Report4 from '../views/Report4'
import Report5 from '../views/Report5'
import Report6 from '../views/Report6'
import NotFound from '../views/NotFound'

import FaIcon from '../components/FaIcon'

import { Layout, Menu, Spin, Badge, Alert } from 'antd'
const { SubMenu, ItemGroup } = Menu
const { Header, Content, Footer, Sider } = Layout



class App extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        session: PropTypes.object.isRequired,
        comboboxes: PropTypes.object,
        counts: PropTypes.object,
        search: PropTypes.object,
        patient: PropTypes.object,
        logout: PropTypes.func.isRequired,
        recoverSession: PropTypes.func.isRequired,
        loadGlobals: PropTypes.func.isRequired,
        closePatientRecord: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        search: null
    }

    componentWillMount() {
        const { session, comboboxes, isGlobalsFetching } = this.props

        if (!isAuthenticated(session)) {
            if (canRecover(session)) {
                if (!session.isRecovering) {
                    this.props.recoverSession().then(() => {
                        this.props.loadGlobals()
                    })
                }
            }
        } else {
            if (!comboboxes.list) {
                if (!isGlobalsFetching) {
                    this.props.loadGlobals()
                }
            }
        }
    }

    handleMenu = ({ key }) => {
        switch (key) {
            case 'logout':
                this.props.logout()
                break;
            default:
                break;
        }
    }

    checkPermissions = (permissions, item) => {
        if (intersection(this.props.session.user.permissions, permissions).length) {
            return item
        }
        return null
    }

    /**
     * Search management
     */
    handleSearch = () => {
        const { search } = this.state
        if (search) {
            this.props.history.push(search)
        }
    }
    handleSelect = (value) => {
        this.setState({ search: value })
    }
    handleDeselect = () => {
        this.setState({ search: null })
    }


    render() {
        const { session, comboboxes, counts, patient, intl } = this.props
        const { user } = this.props.session
        const sidebarKey = this.props.location.pathname

        if (!session.user || !comboboxes.list) {
            if (!canRecover(session)) {
                return (<Redirect to={{ pathname: "/login", state: { from: this.props.location } }} />)
            }
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }

        let homeRedirection = null
        if (user.permissions.indexOf('doctor') !== -1 || user.permissions.indexOf('therapist') !== -1) {
            homeRedirection = <Redirect exact from="/" to="/patients" />
        } else if (user.permissions.indexOf('admin') !== -1) {
            homeRedirection = <Redirect exact from="/" to="/registrations" />
        } else if (user.permissions.indexOf('config') !== -1) {
            homeRedirection = <Redirect exact from="/" to="/settings/countries" />
        }

        return (
            <Layout>
                <Layout style={{ minHeight: '100vh' }}>
                    <Header style={{ background: '#fff', padding: '0px' }}>
                        <Menu theme="light" mode="horizontal" selectable={false} style={{ lineHeight: '62px', paddingRight: '20px', background: (process.env.REACT_APP_CI_ENVIRONMENT === 'test' ? '#faad14' : '#f8f8f8') }} onClick={this.handleMenu}>
                            <Menu.Item disabled={true} className="logo empty-menu-item" style={{ height: '64px' }}><FaIcon icon="leaf" /> Ease<small> - <FormattedMessage id="navbar.description" /></small> <strong>{process.env.REACT_APP_CI_ENVIRONMENT === 'test' ? '- Environnement de test !' : ''}</strong></Menu.Item>
                            <SubMenu title={<span><FaIcon fixedWidth icon="user" />{user ? user.firstName + ' ' + user.lastName : ''}</span>} style={{ float: 'right' }}>
                                <Menu.Item><Link to="/profile"><FaIcon fixedWidth icon="user" /><FormattedMessage id="navbar.profile" /></Link></Menu.Item>
                                <Menu.Item><Link to="/backup"><FaIcon fixedWidth icon="download" /><FormattedMessage id="navbar.backup" /></Link></Menu.Item>
                                <Menu.Divider />
                                <Menu.Item><Link to="/contact"><FaIcon fixedWidth icon="envelope" /><FormattedMessage id="navbar.contact" /></Link></Menu.Item>
                                <Menu.Divider />
                                <Menu.Item key="logout"><FaIcon fixedWidth icon="sign-out" /><FormattedMessage id="navbar.logout" /></Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Header>
                    <Layout>
                        <Sider breakpoint="lg" collapsedWidth="0" width="250px" style={{ background: '#f8f8f8', borderRight: '1px solid #e8e8e8' }}>
                            {/*<div style={{ padding: '25px 15px', borderBottom: '1px solid #e8e8e8' }}>
                                <InputGroup compact>
                                    <Select style={{ width: '178px' }} showSearch allowClear onSelect={this.handleSelect} onDeselect={this.handleDeselect} showArrow={false} optionFilterProp="children" defaultActiveFirstOption={false} placeholder={this.props.intl.formatMessage({ id: 'sidebar.search' })}>
                                        {
                                            Object.keys(search).map((key) => {
                                                if (search[key] && search[key].length) {
                                                    let options
                                                    let label
                                                    switch (key) {
                                                        case 'doctors':
                                                            options = search[key].map((item) => {
                                                                return <Option key={item.id} value={"/doctor/" + item.id}>{item.firstName + " " + item.lastName}</Option>
                                                            })
                                                            label = <FormattedMessage id="search.doctors" />
                                                            break;
                                                        case 'users':
                                                            options = search[key].map((item) => {
                                                                return <Option key={item.id} value={"/user/" + item.id}>{item.firstName + " " + item.lastName}</Option>
                                                            })
                                                            label = <FormattedMessage id="search.users" />
                                                            break;
                                                        case 'plants':
                                                            options = search[key].map((item) => {
                                                                return <Option key={item.id} value={"/plant/" + item.id}>{item.name}</Option>
                                                            })
                                                            label = <FormattedMessage id="search.plants" />
                                                            break;
                                                        case 'actions':
                                                            options = search[key].map((item) => {
                                                                return <Option key={item.id} value={"/action/" + item.id}>{item.name}</Option>
                                                            })
                                                            label = <FormattedMessage id="search.actions" />
                                                            break;
                                                        case 'patients':
                                                            options = search[key].map((item) => {
                                                                return <Option key={item.id} value={"/patient/" + item.id}>{item.firstName + " " + item.lastName}</Option>
                                                            })
                                                            label = <FormattedMessage id="search.patients" />
                                                            break;
                                                        default:
                                                            options = null
                                                            label = null
                                                    }
                                                    return <OptGroup key={key} label={label}>{options}</OptGroup>
                                                }
                                                return null
                                            })
                                        }
                                    </Select>
                                    <Button type="primary" style={{ padding: '0 7px 0 10px' }} onClick={this.handleSearch}><FaIcon icon="search" fixedWidth /></Button>
                                </InputGroup>
                                    </div>*/}
                            {
                                patient ? <Menu className="sidebar patient-record" theme="light" mode="inline" selectedKeys={[sidebarKey]} style={{ background: '#f8f8f8', paddingTop: '15px', paddingBottom: '15px', border: 0, borderBottom: '1px solid #e8e8e8' }}>
                                    <ItemGroup title={<span><FaIcon fixedWidth icon="user" />{patient.firstName} {patient.lastName}<span className="close" onClick={this.props.closePatientRecord}><FaIcon icon="times" fixedWidth /></span></span>}>
                                        <Menu.Item key={"/patient/" + patient.id}><Link to={"/patient/" + patient.id}><FormattedMessage id="sidebar.patient.general" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/semiology"}><Link to={"/patient/" + patient.id + "/semiology"}><FormattedMessage id="sidebar.patient.semiology" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/observations"}><Link to={"/patient/" + patient.id + "/observations"}><FormattedMessage id="sidebar.patient.observations" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/blood-tests"}><Link to={"/patient/" + patient.id + "/blood-tests"}><FormattedMessage id="sidebar.patient.bloodTests" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/biology-function"}><Link to={"/patient/" + patient.id + "/biology-function"}><FormattedMessage id="sidebar.patient.biologyFunction" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/actions"}><Link to={"/patient/" + patient.id + "/actions"}><FormattedMessage id="sidebar.patient.actions" /></Link></Menu.Item>
                                        <Menu.Item key={"/patient/" + patient.id + "/plants"}><Link to={"/patient/" + patient.id + "/plants"}><FormattedMessage id="sidebar.patient.plants" /></Link></Menu.Item>
                                    </ItemGroup>
                                </Menu>
                                    : null
                            }
                            <Menu className="sidebar" theme="light" mode="inline" selectedKeys={[sidebarKey]} style={{ background: '#f8f8f8', paddingTop: '15px', paddingBottom: '15px', border: 0 }}>
                                {this.checkPermissions(['doctor', 'therapist'], <Menu.Item key="/patients">
                                    <Link to="/patients"><FaIcon fixedWidth icon="users" /><FormattedMessage id="sidebar.patients" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['doctor', 'therapist'], <Menu.Item key="/consultations">
                                    <Link to="/consultations"><FaIcon fixedWidth icon="stethoscope" /><FormattedMessage id="sidebar.consultations" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['config'], <Menu.Item key="/actions">
                                    <Link to="/actions"><FaIcon fixedWidth icon="bullseye" /><FormattedMessage id="sidebar.actions" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['config'], <Menu.Item key="/plants">
                                    <Link to="/plants"><FaIcon fixedWidth icon="leaf" /><FormattedMessage id="sidebar.plants" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['admin'], <Menu.Item key="/doctors">
                                    <Link to="/doctors"><FaIcon fixedWidth icon="user-md" /><FormattedMessage id="sidebar.doctors" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['admin'], <Menu.Item key="/registrations">
                                    <Link to="/registrations"><FaIcon fixedWidth icon="user-plus" /><FormattedMessage id="sidebar.registrations" /><Badge count={counts.registrations} style={{ backgroundColor: '#52c41a' }} /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['admin'], <Menu.Item key="/messages">
                                    <Link to="/messages"><FaIcon fixedWidth icon="envelope" /><FormattedMessage id="sidebar.messages" /><Badge count={counts.messages} style={{ backgroundColor: '#52c41a' }} /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['admin'], <Menu.Item key="/reports">
                                    <Link to="/reports"><FaIcon fixedWidth icon="chart-bar" /><FormattedMessage id="sidebar.reports" /></Link>
                                </Menu.Item>)}
                                {this.checkPermissions(['config'], <SubMenu title={<span><FaIcon fixedWidth icon="cogs" /><FormattedMessage id="sidebar.settings" /></span>}>
                                    <Menu.Item key="/settings/norms"><Link to="/settings/norms"><FormattedMessage id="sidebar.settings.norms" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/countries"><Link to="/settings/countries"><FormattedMessage id="sidebar.settings.countries" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/pathologies"><Link to="/settings/pathologies"><FormattedMessage id="sidebar.settings.pathologies" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/pharmaceutical-forms"><Link to="/settings/pharmaceutical-forms"><FormattedMessage id="sidebar.settings.pharmaceuticalForms" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/action-categories"><Link to="/settings/action-categories"><FormattedMessage id="sidebar.settings.actionCategories" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/laboratories"><Link to="/settings/laboratories"><FormattedMessage id="sidebar.settings.laboratories" /></Link></Menu.Item>
                                    <Menu.Item key="/settings/other"><Link to="/settings/other"><FormattedMessage id="sidebar.settings.other" /></Link></Menu.Item>
                                </SubMenu>)}
                            </Menu>
                        </Sider>
                        <Layout style={{ background: '#fff' }}>
                            <Content style={{ margin: '16px' }}>
                                {user.canAddConsultations || <Alert message="Votre abonnement est arrivé à expiration." type="warning" showIcon />}
                                <div style={{ padding: 24, background: '#fff', minHeight: '100%', position: 'relative' }}>
                                    <Switch>
                                        {homeRedirection}
                                        <Route path="/profile" component={Profile} />
                                        <Route path="/backup" component={Backup} />
                                        <Route path="/contact" component={Contact} />
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patients" component={Patients} />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id" component={PatientSheet} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/semiology" component={PatientSemiology} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/observations" component={PatientObservations} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/blood-tests" component={PatientBloodTests} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/biology-function" component={PatientBiologyFunction} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/actions" component={PatientActions} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient/:id/plants" component={PatientPlants} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/patient" component={PatientSheet} exact />)}
                                        {this.checkPermissions(['doctor', 'therapist'], <Route path="/consultations" component={Consultations} />)}
                                        {this.checkPermissions(['config'], <Route path="/actions" component={Actions} />)}
                                        {this.checkPermissions(['config'], <Route path="/action/:id" component={Action} />)}
                                        {this.checkPermissions(['config'], <Route path="/action" component={Action} />)}
                                        {this.checkPermissions(['config'], <Route path="/plants" component={Plants} />)}
                                        {this.checkPermissions(['config'], <Route path="/plant/:id" component={Plant} />)}
                                        {this.checkPermissions(['config'], <Route path="/plant" component={Plant} />)}
                                        {this.checkPermissions(['admin'], <Route path="/doctors" component={Doctors} />)}
                                        {this.checkPermissions(['admin'], <Route path="/users" component={Users} />)}
                                        {this.checkPermissions(['admin'], <Route path="/doctor/:id" component={User} />)}
                                        {this.checkPermissions(['admin'], <Route path="/user/:id" component={User} />)}
                                        {this.checkPermissions(['admin'], <Route path="/registrations" component={Registrations} />)}
                                        {this.checkPermissions(['admin'], <Route path="/messages" component={Messages} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports" component={Reports} exact />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/1" component={Report1} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/2" component={Report2} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/3" component={Report3} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/4" component={Report4} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/5" component={Report5} />)}
                                        {this.checkPermissions(['admin'], <Route path="/reports/6" component={Report6} />)}
                                        {this.checkPermissions(['config'], <Route path="/settings/:name(pathologies|countries|pharmaceutical-forms|action-categories)" component={SettingsGenericCombo} />)}
                                        {this.checkPermissions(['config'], <Route path="/settings/laboratories" component={SettingsLaboratories} />)}
                                        {this.checkPermissions(['config'], <Route path="/settings/norms" component={SettingsNorms} />)}
                                        {this.checkPermissions(['config'], <Route path="/settings/other" component={SettingsOther} />)}
                                        <Route component={NotFound} />
                                    </Switch>
                                </div>
                            </Content>
                            <Footer style={{ textAlign: 'center', background: '#f8f8f8' }}>
                                &copy; 2020 - <FormattedMessage id="footer.createdBy" /> <a href="https://www.neoxis.be"><FaIcon icon="code" /> Neoxis</a>
                                <div style={{ float: "right" }}><FaIcon icon="info-circle" style={{ cursor: "pointer" }} onClick={() => showAbout(intl)} /></div>
                            </Footer>
                        </Layout>
                    </Layout>
                </Layout>
            </Layout>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session,
    comboboxes: state.comboboxes,
    isGlobalsFetching: state.isGlobalsFetching,
    counts: state.counts,
    search: state.search,
    patient: state.patient
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    logout,
    recoverSession,
    loadGlobals,
    closePatientRecord
})(App)))



// WEBPACK FOOTER //
// ./src/containers/App.js